import { clsx } from 'clsx'
import { Loader } from 'component/Loader'
import { Space } from 'component/Space'
import { observer } from 'mobx-react-lite'
import { useDemo } from 'page/catalog/store/CatalogContext'
import { itemPreview } from 'page/catalog/store/ItemPreviewStore'
import css from './SizingButton.module.scss'

export const SizingButton = observer(() => {
  const demo = useDemo()
  const { lang, sizing } = demo.data.product
  const { item_id } = itemPreview.it.item
  const className = clsx('showoff-sizing', css.button)

  return <div
    className={className}
    data-lang={lang}
    data-product={sizing}
    data-item={item_id}>
    <Space wide tall center>
      <Loader small />
    </Space>
  </div>
})
